/* eslint-disable react/no-unknown-property */
/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 ./public/models/ExternalWallInsulation.glb --types 
*/

import React from 'react';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';
import { GLTF } from 'three-stdlib';

type GLTFResult = GLTF & {
  nodes: {
    Cube: THREE.Mesh;
    Cube198: THREE.Mesh;
  };
  materials: {
    wall: THREE.MeshStandardMaterial;
    ['HIGHLIGHT.005']: THREE.MeshStandardMaterial;
  };
};

export function Model({ active, scale }: { active: boolean; scale: number }) {
  const { nodes, materials } = useGLTF('/models/ExternalWallInsulation.glb') as GLTFResult;
  return (
    <group dispose={null} scale={scale}>
      <mesh
        geometry={nodes.Cube.geometry}
        material={active ? materials['HIGHLIGHT.005'] : materials.wall}
        position={[-0.859, 0.256, 0]}
      />
    </group>
  );
}

useGLTF.preload('/models/ExternalWallInsulation.glb');
